/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, fromJS } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
} from './action-types.js';
import { Sector } from './types.js';
import type { RawSector } from './types.js';

/* **************************************************************************
 * Enclaves
 * *************************************************************************/
const listToOrderedMap = (list) => {
  return fromJS(list)
    .toOrderedMap()
    .map(Sector)
    .mapKeys((k, v) => v.get('id'));
};

type State = OrderedMap<number, Sector>;

// TODO: Properly type this action
export const sectors = (state: State = OrderedMap(), action: Action<RawSector>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUCCESS:
    return listToOrderedMap(payload);
  default:
    return state;
  }
};

export const loading = (state: boolean = false, action: Action<any>) => {
  switch (action.type) {
  case FETCH:
    return true;
  case FETCH_SUCCESS:
  case FETCH_FAILURE:
    return false;
  default:
    return state;
  }
};

export default combineReducers({
  sectors,
  loading,
});



// WEBPACK FOOTER //
// ./src/app/modules/sectors/stores.js